export default __webpack_public_path__ + "static/media/card_s_red.efd2cb09.png";